import React from "react";

interface ResponsiveGridContextValue {
  setHasFocus: (hasFocus: boolean) => void;
  hasFocus: boolean;
}

export const ResponsiveGridContext =
  React.createContext<ResponsiveGridContextValue>({
    setHasFocus: () => {},
    hasFocus: false,
  });

export const ResponsiveGridProvider: React.FC<
  React.PropsWithChildren<{
    hasFocus: boolean;
    setHasFocus: (hasFocus: boolean) => void;
  }>
> = ({ children, hasFocus, setHasFocus }) => (
  <ResponsiveGridContext.Provider value={{ hasFocus, setHasFocus }}>
    {children}
  </ResponsiveGridContext.Provider>
);
